import { sortBy } from 'es-toolkit';
import type {
  JsonWebMessageData,
  JsonWebMessageRender,
  TradingGroup,
  TradingMessageSession,
} from 'src/store/shared/tradingBots/types';
import { parseMessage } from 'src/store/shared/tradingBots/utils';

export const getTradingGroupOptions = (groupList: TradingGroup[] | null) => {
  const list: Record<string, { value: string; label: string }[]> = {};
  (groupList ?? []).forEach(({ name, id, exchangeID }) => {
    if (!list[exchangeID]) {
      list[exchangeID] = [];
    }

    list[exchangeID].push({
      value: String(id),
      label: name,
    });
  });
  return list;
};

export const getTradingMessages = (
  messageLog: JsonWebMessageRender[],
  sessionDetails: TradingMessageSession | null,
) => {
  const sessionMessages = messageLog.filter(
    (message) => message.session === sessionDetails?.session,
  );

  if (sessionMessages && sessionMessages.at(-1)?.message.includes('User')) {
    sessionMessages.push({
      messageID: sessionMessages.at(-1)?.messageID ?? 0,
      session: sessionDetails?.session ?? '',
      ...parseMessage('Wait for the bot to respond...'),
    });
  }

  return sessionMessages;
};

export const getLastMessageId = (messageLog: JsonWebMessageData[]) => {
  const lastMessage = sortBy(messageLog, ['messageID']).at(-1);
  return lastMessage ? lastMessage.messageID : 0;
};

export const getCurrentExchange = (
  exchanges: number[],
  targetAccount: string | null,
  defaultExchange: number | null,
) => {
  if (targetAccount === null || !exchanges.length) {
    return defaultExchange ?? null;
  }
  return exchanges.find((item) => item === +targetAccount) ?? defaultExchange ?? null;
};
